import slug from 'slugify';

export function slugify(text, options = {}) {
  return slug(text, {lower: true, ...options});
}
